import { SliderToggle } from "components/UIComponents/SliderToggle";
import { ReactNode } from "react"
import { ControlLine } from "./ControlLine";

export type ToggleLineProps = {
    text: ReactNode;
    enabled: boolean;
    onChange: (value: boolean) => void;
};

export const ToggleLine = (props: ToggleLineProps) => {
    return <ControlLine
        left={props.text} 
        right={
            <div className="flex-none h-7 w-12">
                <SliderToggle
                    enabled={props.enabled}
                    setEnabled={props.onChange}
                />
            </div>
        }
    />
}
